<div *ngIf="loading" id="app-loading" class="opac-loading">
  <div class="loader running"></div>
</div>
<div
  *ngIf="loginerror"
  class="d-flex align-items-center justify-content-center"
  style="background-color: #f0f0f0; min-height: 100vh;"
>
  <div class="w-100" style="max-width: 400px;">

    <div class="text-center px-4 py-5">
      <h1 class="display-3">Error</h1>
      <h4 class="pt-1">Could not Login!</h4>
      <p class="text-muted">{{ loginmsg }}</p>

      <div class="input-group mt-4 align-items-center">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fa fa-refresh"></i></span>
        </div>
        <input
          class="form-control bg-white"
          id="prependedInput"
          placeholder="Please, start over..."
          size="16"
          type="text"
          [readonly]="true"
        />
        <div class="input-group-append">
          <button class="btn btn-primary" (click)="goHome()">Home</button>
        </div>
      </div>
    </div>

  </div>
</div>
